import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '~/vcl/atoms/01-forms/01-button';
import { FormActions } from '~/vcl/molecules/01-form/01-form-actions';

interface JobFormButtonsProps {
  /**
   * The flag that indicates if the form is submitting.
   * @default false
   */
  isSubmitting: boolean;
  /**
   * The flag that indicates if the form buttons should be shown.
   */
  showButtons?: boolean;
  /**
   * The label of the save button.
   */
  saveLabel: ReactNode;
  /**
   * The flag that indicates if the job mutation is submitting.
   */
  submittingJobMutation?: boolean;
  /**
   * The function that is called when the cancel button is clicked.
   */
  onFormCancel?: () => void;
}

export const JobFormButtons = ({
  isSubmitting = false,
  saveLabel,
  showButtons,
  submittingJobMutation,
  onFormCancel,
}: JobFormButtonsProps) =>
  showButtons ? (
    <FormActions orientation="right">
      {onFormCancel && (
        <Button
          type="button"
          buttonStyle="secondary"
          raised={false}
          onClick={(e) => {
            if (onFormCancel) {
              onFormCancel();
            }
          }}
        >
          <FormattedMessage id="cancel" defaultMessage="Cancel" />
        </Button>
      )}
      <Button
        disabled={isSubmitting || submittingJobMutation}
        buttonStyle="primary"
        data-test-id="ef-submit"
        type="submit"
      >
        {saveLabel ? (
          saveLabel
        ) : (
          <FormattedMessage id="save" defaultMessage="Save" />
        )}
      </Button>
    </FormActions>
  ) : null;
